export default "__VITE_ASSET__fc521768__"